import apiService from './authApi';

export const customDateApi = {
  // ✅ Place One Time Order (Custom Date)
  placeOneTimeOrder: async (data) => {
    try {
      const response = await apiService.api.post('/tiffin/date-wise/order', data);
      console.log('✅ Custom date order placed:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Custom date order error:', error);
      throw error;
    }
  },

  // ✅ Get Custom Date Order Details by ID (Use this instead of list)
  getCustomDateOrderDetails: async (orderId) => {
    try {
      const response = await apiService.api.get(`/tiffin/date-wise/${orderId}`);
      console.log('✅ Custom date order details:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Get custom date order details error:', error);
      throw error;
    }
  },

  // ✅ Select Service Type
  selectServiceType: async (type) => {
    try {
      const response = await apiService.api.post('/tiffin/select-type', { type });
      console.log('✅ Service type selected:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Select service type error:', error);
      throw error;
    }
  },

  // ✅ Get Service Type
  getServiceType: async () => {
    try {
      const response = await apiService.api.get('/tiffin/select-type');
      console.log('✅ Service type:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Get service type error:', error);
      throw error;
    }
  },

  // ✅ Select Service
  selectService: async (service) => {
    try {
      const response = await apiService.api.post('/user/select-service', { service });
      console.log('✅ Service selected:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Select service error:', error);
      throw error;
    }
  },

  // ✅ Get Service
  getService: async () => {
    try {
      const response = await apiService.api.get('/user/select-service');
      console.log('✅ Service:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Get service error:', error);
      throw error;
    }
  },
};